import type { SVGProps } from 'react';
import * as React from 'react';

const UsersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/users">
      <path
        id="Icon"
        d="M15 19.1276C15.8329 19.37 16.7138 19.5 17.625 19.5C19.1037 19.5 20.5025 19.1576 21.7464 18.5478C21.7488 18.4905 21.75 18.4329 21.75 18.375C21.75 16.0968 19.9031 14.25 17.625 14.25C16.2069 14.25 14.956 14.9655 14.2136 16.0552M14.2136 16.0552C13.129 14.085 11.0329 12.75 8.625 12.75C5.10418 12.75 2.25 15.6042 2.25 19.125C2.25 19.1615 2.25031 19.198 2.25092 19.2343C4.11264 20.3552 6.29353 21 8.625 21C10.9565 21 13.1374 20.3552 14.9991 19.2343C14.9997 19.1988 15 19.1632 15 19.1276V19.125C15 18.0121 14.7148 16.9658 14.2136 16.0552ZM12 6.375C12 8.23896 10.489 9.75 8.625 9.75C6.76104 9.75 5.25 8.23896 5.25 6.375C5.25 4.51104 6.76104 3 8.625 3C10.489 3 12 4.51104 12 6.375ZM20.25 8.625C20.25 10.0747 19.0747 11.25 17.625 11.25C16.1753 11.25 15 10.0747 15 8.625C15 7.17525 16.1753 6 17.625 6C19.0747 6 20.25 7.17525 20.25 8.625Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default UsersIcon;
